import { lazy } from 'react';

import ChangeInvestmentsDetails from 'pages/ChangeInvestmentsDetails';
import IndexUpdateDetails from 'pages/IndexUpdateDetails';
import FeesDetails from 'pages/FeesDetails';
import WithdrawalDetails from 'pages/WithdrawalDetails';
import { RouteDefinition } from "./types";
import RegisterPage from 'pages/Auth/RegisterPage';
import TaxesDetails from 'pages/TaxesDetails';

const Dashboard = lazy(() => import('../pages/Dashboard'));

const Request = lazy(() => import('../pages/Request'));
const DepositDetails = lazy(() => import('../pages/DepositDetails'));

const RegisterDocuments = lazy(() => import('../pages/Auth/Documents'));
const RegisterPortfolio = lazy(() => import('../pages/Auth/CreatePortfolio'));
const Documents = lazy(() => import('../pages/Documents'));
const DocumentsPrintForm = lazy(() => import("../pages/Auth/Documents/printform"));

const CompleteProfile = lazy(() => import('../pages/Auth/CompleteProfile'));
const CompleteProfileStart = lazy(() => import('../pages/Auth/CompleteProfileStart'));

const DocsPending = lazy(() => import('../pages/DocsPending'));
const UserDetails = lazy(() => import('../pages/UserDetails'));
const UserStatement = lazy(() => import('../pages/Auth/Documents/UserStatement'));
const UserLoanAgreement =  lazy(() => import('../pages/Auth/Documents/UserLoanAgreement'));
const BookCall = lazy(() => import('../pages/Auth/BookCall'));
const CallVerified = lazy(() => import('../pages/Auth/CallVerified'));

export const privateroutes: RouteDefinition[] = [
    {
        component: Dashboard,
        exact: true,
        name: 'dashboard',
        path: '/',
        parent: 'dashboard',
        access: true
    },
    {
        component: Request,
        exact: true,
        name: 'request',
        path: '/request',
        parent: 'request',
        access: true
    },
    {
        component: Request,
        exact: true,
        name: 'request-withdrawals',
        path: '/request/withdrawals',
        props: {
            menu: "withdrawals"
        },
        parent: 'request',
        access: true
    },
    {
        component: Request,
        exact: true,
        name: 'request-index-changes',
        path: '/request/index-changes',
        props: {
            menu: "index-changes"
        },
        parent: 'request',
        access: true
    },
    {
        component: Request,
        exact: true,
        name: 'request-fees',
        path: '/request/fees',
        props: {
            menu: "fees"
        },
        parent: 'request',
        access: true
    },
    {
        component: Request,
        exact: true,
        name: 'request-taxes',
        path: '/request/taxes',
        props: {
            menu: "taxes"
        },
        parent: 'request',
        access: true
    },
    {
        component: Request,
        exact: true,
        name: 'backoffice-docs',
        path: '/request/backoffice-docs',
        props: {
            menu: "backoffice-docs"
        },
        parent: 'request',
        access: true
    },
    {
        component: Request,
        exact: true,
        name: 'request-change-investments',
        path: '/request/change-investments',
        props: {
            menu: "change-investments"
        },
        parent: 'request',
        access: true
    },
    {
        component: DepositDetails,
        exact: true,
        name: 'deposit-details',
        path: '/deposit/:id',
        parent: 'request',
        access: true
    },
    {
        component: WithdrawalDetails,
        exact: true,
        name: 'withdrawal-details',
        path: '/withdrawal/:id',
        parent: 'request',
        access: true
    },
    {
        component: ChangeInvestmentsDetails,
        exact: true,
        name: 'change-investments-details',
        path: '/change-investments/:id',
        parent: 'request',
        access: true
    },
    {
        component: IndexUpdateDetails,
        exact: true,
        name: 'index-update-details',
        path: '/index-changes/:id',
        parent: 'request',
        access: true
    },
    {
        component: FeesDetails,
        exact: true,
        name: 'fees-details',
        path: '/fees/:id',
        parent: 'request',
        access: true
    },
    {
        component: TaxesDetails,
        exact: true,
        name: 'taxes-details',
        path: '/taxes/:id',
        parent: 'request',
        access: true
    },
    {
        component: Documents,
        exact: true,
        name: 'documents',
        path: '/documents',
        parent: 'documents',
        access: true
    },
    {
        component: DocumentsPrintForm,
        exact: true,
        name: 'documents-print-form',
        path: '/documents/printform',
        parent: 'documents',
        access: true
    },
    {
        component: RegisterPage,
        exact: false,
        name: 'register-page',
        path: '/register',
        access: false
    },
    {
        component: DocsPending,
        exact: true,
        name: 'docs-pending',
        path: '/docs-pending',
        parent: 'documents',
        access: true
    },
    {
        component: UserDetails,
        exact: true,
        name: 'user-details',
        path: '/user/details',
        access: true
    },
    {
        component: UserStatement,
        exact: true,
        name: 'user-statement',
        path: '/user/statement',
        parent: 'documents',
        access: false
    },
    {
        component: UserLoanAgreement,
        exact: true,
        name: 'user-loan-agreement',
        path: '/user/loan-agreement',
        parent: 'documents',
        access: false
    },
    //documents
    // {
    //     component: CompleteProfile,
    //     exact: true,
    //     name: 'user-kyc',
    //     path: '/user/kyc',
    //     parent: 'documents',
    //     access: false
    // },
    // {
    //     component: UserKYCStep2,
    //     exact: true,
    //     name: 'user-kyc-step2',
    //     path: '/user/kyc/step2',
    //     parent: 'documents',
    //     access: false
    // },
    // {
    //     component: UserKYCStep3,
    //     exact: true,
    //     name: 'user-kyc-step3',
    //     path: '/user/kyc/step3',
    //     parent: 'documents',
    //     access: false
    // },
    // {
    //     component: UserKYCStep4,
    //     exact: true,
    //     name: 'user-kyc-step4',
    //     path: '/user/kyc/step4',
    //     parent: 'documents',
    //     access: false
    // },
    //  {
    //     component: UserKYCStep4,
    //     exact: true,
    //     name: 'user-kyc-step5',
    //     path: '/user/kyc/step5',
    //     parent: 'documents',
    //     access: false
    // },

];
